import classes from "./BoxesContainer.module.css";
import { MuuriComponent } from "muuri-react";
import "./BoxesContainer.css";
import Box from "../../../TEMPLATE/components/box/Box";
import { UvUrl } from "../../hardCodeData/DATA";
import Meteor from "../../../TEMPLATE/components/categories/meteo/Meteor";
import Meshlium from "../../../TEMPLATE/components/categories/meshlium/Meshlium";
import UvIndexes from "../../../TEMPLATE/components/categories/uv/UvIndexes";
import Weather from "../../../TEMPLATE/components/categories/weather/Weather";
import CustomCategoryUniversity from "../categories/CustomCategoryUniversity";
import LanguageContext from "../../../TEMPLATE/hooks/language-context";
import MapPOIS from "../../../TEMPLATE/components/categories/mapPOIS/MapPOIS";
import CustomCategoryDiav from "../categories/CustomCategoryDiav";
import Applicants from "../categories/Applicants";
import IanosEnergy from "../categories/IanosEnergy";
import Parking from "../categories/Parking";
import MapPOISAMEA from "../../../TEMPLATE/components/categories/MapPOISAMEA/MapPOISAMEA";
import WelcomeMessage from "../../../TEMPLATE/components/Home/Welcome/WelcomeMessage";
import styled from "styled-components";
import ThreeDimensions from "../categories/ThreeDimensions";
import Mapping from "../categories/Mapping";
import Publics from "../categories/Publics";
import Hum from "../categories/Hum";
import { useAllContexts } from "../../../TEMPLATE/hooks/useAllContexts";
import Power from "../categories/Power";
import { useTranslation } from "react-i18next";
import Clock from "../../../TEMPLATE/components/categories/clock/Clock";

const maxEntitiesLargeBox = 9;
const maxEntitiesMediumBox = 2;

const options = {
  dragSortHeuristics: {
    sortInterval: 0,
  },
  layoutDuration: 400,
  dragRelease: {
    duration: 400,
    easing: "ease-out",
  },
  dragEnabled: true,
  dragStartPredicate: function (item, hammerEvent) {
    if (hammerEvent.target.matches("#draggable")) {
      return true;
    }
    return false;
    // distance: 0,
    // delay: 500,
  },
  dragContainer: document.body,
  // The placeholder of an item that is being dragged.
  dragPlaceholder: {
    enabled: true,
    createElement: function (item) {
      // The element will have the Css class ".muuri-item-placeholder".
      return item.getElement().cloneNode(true);
    },
  },
};
const BoxesContainer = () => {
  const { hum } = useAllContexts();
  const { t } = useTranslation();
  return (
    <BoxesWrapper>
      <MuuriComponent {...options}>
        {/* Applicants */}
        {/* <Box
          className={[classes.medium, classes.applicants].join(" ")}
          title="ΕΞΥΠΗΡΕΤΗΣΗ"
        >
          <Applicants />
        </Box> */}

        <Box className={classes.large} typeId="1">
          <Meteor
            typeId="1"
            title={t("environmental.title")}
            showSubTitle={true}
            type="environmental"
          />
        </Box>
        <Box className={classes.large} typeId="1">
          <Meteor
            typeId="1"
            title={t("environmental.title")}
            showSubTitle={true}
            type="environmental"
            isDaily
          />
        </Box>

        {/* <Box
          className={[classes.medium, classes.mapping].join(" ")}
          title="ΕΦΑΡΜΟΓΕΣ ΧΑΡΤΟΓΡΑΦΗΣΗΣ"
        >
          <Mapping />
        </Box> */}

        {/* <Box className={classes.map_box} typeId="4">
          <MapPOIS typeId="4" title="WIFI HOTSPOTS" cityName="korydallos" />
        </Box> */}

        {/* <Box className={classes.large} typeId="5">
          <Meteor
            typeId="5"
            title="ΜΕΤΕΩΡΟΛΟΓΙΚΑ ΔΕΔΟΜΕΝΑ"
            showSubTitle={true}
          />
        </Box> */}

        {/*<Box className={classes.map_box} typeId="7">
          <MapPOIS
            typeId="7"
            title="ΣΗΜΕΙΑ ΕΝΔΙΑΦΕΡΟΝΤΟΣ"
            cityName="korydallos"
          />
        </Box>*/}

        {/*<Box className={classes.map_box} typeId="9">
          <MapPOIS typeId="9" title="ΚΑΔΟΙ" cityName="korydallos" />
        </Box>*/}

        {/*<Box className={classes.map_box} typeId="30">
          <MapPOIS typeId="30" title="ΕΞΥΠΝΑ ΠΑΓΚΑΚΙΑ" cityName="korydallos" />
        </Box>*/}

        {/* <Box className={classes.map_box} typeId="10">
          <MapPOIS typeId="10" title="ΥΔΡΟΜΕΤΡΑ" cityName="korydallos" />
        </Box> */}

        {/* <Box className={classes.map_box} typeId="8">
          <MapPOIS typeId="8" title="ΔΙΑΧ/ΣΗ ΣΤΟΛΟΥ" cityName="skoufas" />
        </Box> */}

        {/* <Box
          className={[classes.medium, classes.publics].join(" ")}
          title="ΔΗΜΟΣΙΕΣ ΔΙΑΒΟΥΛΕΨΕΙΣ"
        >
          <Publics />
        </Box> */}

        {/* <Box className={`${classes.large} ${classes.ianosEnergy}`} typeId="12">
          <Power />
        </Box> */}

        {/* <Box className={classes.large} typeId="12">
          <Hum data={hum.humData} title="ΚΑΤΑΝΑΛΩΣΗ ΕΝΕΡΓΕΙΑΣ" typeId="12" />
        </Box> */}

        {/*
         <Box
          className={[classes.medium, classes.uv_style].join(" ")}
          typeId="5"
        >
          <UvIndexes
            title={t("uv.title")}
            indexName="ΔΕΙΚΤΗΣ UV"
            typeId="5"
            indexType="uv"
          />
        </Box>

        <Box
          className={[classes.medium, classes.uv_style].join(" ")}
          typeId="5"
        >
          <UvIndexes
            title={t("discomfort.title")}
            indexName="ΔΕΙΚΤΗΣ ΔΥΣΦΟΡΙΑΣ"
            typeId="5"
            indexType="discomfort"
          />
        </Box>

        <Box
          className={[classes.medium, classes.uv_style].join(" ")}
          typeId="5"
        >
          <UvIndexes
            title={t("humidity.title")}
            indexName="ΔΕΙΚΤΗΣ ΥΓΡΑΣΙΑΣ"
            typeId="5"
            indexType="humidity"
          />
        </Box>

        <Box
          className={[classes.medium, classes.uv_style].join(" ")}
          typeId="5"
        >
          <UvIndexes
            title={t("air_quality.title")}
            indexName="ΠΟΙΟΤΗΤΑ ΑΕΡΑ"
            typeId="5"
            indexType="air_quality"
          />
        </Box>
         */}

        <Box
          className={[classes.medium, classes.weatherBox].join(" ")}
          title="ΠΕΡΙΒΑΛΛΟΝΤΙΚΑ"
        >
          <Weather />
        </Box>

        <Box
          className={[classes.medium, classes.weatherBox].join(" ")}
          title="clock"
        >
          <Clock />
        </Box>

        <Box
          className={[classes.medium, classes.customCategory_university].join(
            " "
          )}
          title="ΕΞΥΠΗΡΕΤΗΣΗ"
        >
          <CustomCategoryUniversity />
        </Box>

        {/* <Box className={classes.map_box} typeId="31">
          <MapPOIS typeId="31" title="ΠΙΝΑΚΙΔΕΣ ΠΛΗΡΟΦΟΡΗΣΗΣ" />
        </Box> */}

        {/* <Box
          className={[classes.medium, classes.parking].join(" ")}
          title={"Παρκινγ"}
        >
          <Parking id={0} typeId={"24"} />
        </Box> */}
      </MuuriComponent>
    </BoxesWrapper>
  );
};

export default BoxesContainer;

const BoxesWrapper = styled.div`
  width: 100%;
  height: 100%;
  overflow-y: auto;
  margin: 0 auto;

  @media only screen and (max-width: 878px) {
    width: 592px;
  }
  @media only screen and (max-width: 599px) {
    width: 100vw;
    padding-left: calc((100vw - 280px) / 2);
  }

  scrollbar-color: #373b40 #1a1d21;
  scrollbar-width: thin;
`;
